import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/global-state/store';

import { getAppliedPointsInCart } from './rewards.utils';

export const selectAppliedLoyaltyRewards = ({ loyalty }: RootState) => {
  return loyalty.rewards.appliedLoyaltyRewards;
};

export const selectAppliedLoyaltyRewardsArray = ({ loyalty }: RootState) => {
  return loyalty.rewards.appliedLoyaltyRewardsArray;
};

export const selectAvailableLoyaltyRewardsMap = ({ loyalty }: RootState) => {
  return loyalty.rewards.availableLoyaltyRewardsMap;
};

export const selectIsPricingRewardApplication = ({ loyalty }: RootState) => {
  return loyalty.rewards.isPricingRewardApplication;
};

export const selectStagedCartPoints = ({ loyalty }: RootState) => {
  return loyalty.rewards.stagedCartPoints;
};

export const selectTotalTimesRewardApplied = ({ loyalty }: RootState) => {
  return loyalty.rewards.totalTimesRewardApplied;
};

export const selectShouldRefetchRewards = ({ loyalty }: RootState) => {
  return loyalty.rewards.shouldRefetchRewards;
};

export const selectAppliedPoints = ({ loyalty }: RootState) =>
  getAppliedPointsInCart(loyalty.rewards);

// This selector also serves as a placeholder, when the Reward Unstacking is fully released
// we can start working on removing all the logic the supports having several applied
// rewards, which won't be the case anymore
export const selectAppliedReward = createSelector(
  selectAppliedLoyaltyRewardsArray,
  rewards => rewards?.[0]
);

export const selectRewardsFeedbackMap = ({ loyalty }: RootState) => {
  return loyalty.rewards.rewardsFeedbackMap;
};
